const ArrowRightIcon = ({ fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.43 18.823C14.24 18.823 14.05 18.753 13.9 18.603C13.61 18.313 13.61 17.833 13.9 17.543L19.44 12.003L13.9 6.46305C13.61 6.17305 13.61 5.69305 13.9 5.40305C14.19 5.11305 14.67 5.11305 14.96 5.40305L21.03 11.473C21.32 11.763 21.32 12.243 21.03 12.533L14.96 18.603C14.81 18.753 14.62 18.823 14.43 18.823Z"
        fill={fill || "#0051FF"}
      />
      <path
        d="M20.33 12.753H3.5C3.09 12.753 2.75 12.413 2.75 12.003C2.75 11.593 3.09 11.253 3.5 11.253H20.33C20.74 11.253 21.08 11.593 21.08 12.003C21.08 12.413 20.74 12.753 20.33 12.753Z"
        fill={fill || "#0051FF"}
      />
    </svg>
  );
};

export default ArrowRightIcon;
